import React from 'react';
import { Typography } from '@mui/material';

const Hint = () => {
  return (
    <Typography textAlign="center" color="text.secondary" fontSize="15px">
       Scroll right to see more...
    </Typography>
  )
}

export default Hint